// Func = limiting Scope for this file
var lastScrollTop = 0;

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate-fade-2');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	};
};

(function(){

	$(document).ready(function () {


		//Acts when scroll down page.
		// $(window).scroll(function (event) {
		// 	scrollDown();
		// });

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};
	/////// Video Home /////
	var videoUrl;
	$('.open-video2').click(function(event){
		event.preventDefault();
		videoUrl = $(this).attr('data-video');
	})
	$('.open-video2').fancybox({
		afterShow	:	function() {
			$('#lightbox-video').attr('src',videoUrl);
			$('#lightbox-video')[0].play();
		},
		overlayShow : true,
		centerOnScroll : true,
		speedIn : 100,
		speedOut : 50,
		allowfullscreen:true,
		width         : '100%',
		height        : '100%',
		autosize: false
	});
	////// TABS ///////
	$('.accommodations__tabs > li').click(function(){
		const thisIndex = $(this).index();
		$('.accommodations__content').slick('slickGoTo',thisIndex);
	})	
	$('.accommodations__content').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		const current_slide = nextSlide + 1;
		$('.accommodations__tabs li').removeClass('active');
		$('.accommodations__tabs li:nth-child('+current_slide+')').addClass('active');
	  });

	const observers_anchor = document.querySelectorAll(".js-observer-anchor");
	if(observers_anchor){
		let options_anchor = {
			root: null, // relative to document viewport 
			rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
			threshold: [0.55] // visible amount of item shown in relation to root
			//threshold: 0
		}
		function handler_anchor(entries, observer) {
			let entry;
			entries.forEach(function(entry){
				const entry_id = entry.target.id;
				const entry_link = document.querySelector('.privary-navigation a[href="#'+entry_id+'"]');
				if (entry.isIntersecting) {
					//console.log(entry_link);
					if(!entry_link.classList.contains('active')){
						console.log('adding class '+entry_id+'');
						entry_link.classList.add('active');
					}else{
						console.log('removing: '+entry_id+'');
					}
				}else{
					entry_link.classList.remove('active');
				}
			});
		}
		let observable_anchor = new IntersectionObserver(handler_anchor, options_anchor);
		observers_anchor.forEach(function(item) {
			observable_anchor.observe(item);
		})
	};

	const home_nav = document.querySelectorAll('.privary-navigation a, .irresistible-offers a');
	if(home_nav){
		for(let i = 0; i<home_nav.length; i++ ){
			home_nav[i].addEventListener('click', function(event){
				event.preventDefault();
				const nav_href = home_nav[i].getAttribute('href');
				const href_offset = document.querySelector(nav_href).getBoundingClientRect();
				const top_pos = href_offset.top;
				const scroll_y = window.scrollY;
				console.log(top_pos);
				$('html,body').animate({
					scrollTop: (scroll_y + top_pos)
				},1200);
			})
		}
	};

	const home_nav_tb = document.querySelectorAll('.nav-mobile .privary-navigation a');
	console.log(home_nav_tb);	
	if(home_nav_tb){
		let menu = document.querySelector('.menu-content');
		for(let i = 0; i<home_nav_tb.length; i++ ){
			home_nav_tb[i].addEventListener('click', function(event){
				event.preventDefault();
				const nav_href = home_nav[i].getAttribute('href');
				const href_offset = document.querySelector(nav_href).getBoundingClientRect();
				const top_pos = href_offset.top;
				const scroll_y = window.scrollY;
				menu.classList.remove('show');
				console.log(top_pos);
				$('html,body').animate({
					scrollTop: (scroll_y + top_pos)
				},1200);
			})
		}
	};

	const button_nav = document.querySelectorAll('.btn-planning a');
	if(button_nav){
		for(let i = 0; i< button_nav.length; i++ ){
			button_nav[i].addEventListener('click', function(event){
				event.preventDefault();
				const nav_href = button_nav[i].getAttribute('href');
				const href_offset = document.querySelector(nav_href).getBoundingClientRect();
				const top_pos = href_offset.top;
				const scroll_y = window.scrollY;
				console.log(top_pos);
				$('html,body').animate({
					scrollTop: (scroll_y + top_pos)
				},1200);
			})
		}
	};

	

	var firstEntry = false;
	function scrollDownAction(topNumber, classHeader) {


		var logoHeader = document.querySelector('.header .js-scroll-logo img' ) || [];
		var getLogoUrl;
		var getDataLogo;

		if(logoHeader.length !== 0) {
			getLogoUrl = logoHeader.src || [];
			getDataLogo = logoHeader.getAttribute('data-scroll') || [];
		}

		var headerElement = document.querySelector('header' );

		if(!firstEntry) {
			console.log(getDataLogo.length);
			if(getDataLogo.length > 0) {
				window.addEventListener('scroll', function () {

					if( pageYOffset > topNumber ) {
						headerElement.classList.add( classHeader );
						logoHeader.src = getDataLogo;
					} else {
						headerElement.classList.remove( classHeader );
						logoHeader.src = getLogoUrl;
					}

				});
			} else {
				window.addEventListener('scroll', function () {

					if( pageYOffset > topNumber ) {
						headerElement.classList.add( classHeader );
					} else {
						headerElement.classList.remove( classHeader );
					}

				});
			}
			firstEntry = true;
		}
	}



	function showMenu(){
		let burger = document.querySelector('.header-mobile .menu-bgr');
		if(burger){
			let close = document.querySelector('.menu-content .close-menu');
			let menu = document.querySelector('.menu-content');
			burger.addEventListener('click', event =>{
				menu.classList.add('show');
			})
			close.addEventListener('click', event =>{
				menu.classList.remove('show');
			})
		}
		
	};
	showMenu();
}());

